const initialOnboard = [
  "https://stgkippapps.blob.core.windows.net/img/onboard-inicial-1.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-inicial-2.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-inicial-3.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-inicial-4.png",
  "https://stgkippapps.blob.core.windows.net/img/onboard-inicial-5.png"
];

export default initialOnboard;
